import React, { useCallback, useState } from 'react';
import MUIDataTable from 'mui-datatables';
import { useProfits } from '../../../../libs/hooks';
import { IconButton, makeStyles, Paper } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import ProfitEditModal from '@pages/profits/body/ProfitEditModal';

const options = {
  filter: true,
  filterType: 'dropdown',
  responsive: 'vertical',
  search: true,
  rowsPerPage: 10,
  selectableRowsOnClick: false,
  selectableRowsHideCheckboxes: true
};

const useStyles = makeStyles(theme => ({
  add: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));

const ProfitTable = ({ date }) => {
  const [editItem, setEditItem] = useState();

  const onPressEdit = useCallback(item => {
    setEditItem(item);
  }, []);

  const { headers, data, updateItem } = useProfits(date, onPressEdit);

  const onPressAdd = useCallback(async () => {
    setEditItem({
      isAlarm: false,
      code: '',
      codeName: '',
      estimatedPrice: 0,
      opinion: ''
    });
  }, []);

  const classes = useStyles();

  return (
    <>
      <MUIDataTable data={data} columns={headers} options={options} />

      <Paper elevation={4} className={classes.add}>
        <IconButton onClick={onPressAdd}>
          <AddIcon />
        </IconButton>
      </Paper>

      <ProfitEditModal
        editItem={editItem}
        visible={!!editItem}
        close={() => setEditItem(null)}
        onPressSubmit={item => {
          updateItem(item);
        }}
      />
    </>
  );
};

export default ProfitTable;
